(function () {
    const radioButtons = [...document.querySelectorAll('[data-product-radio]')];
    const dropdownSelects = [...document.querySelectorAll('variant-selects select')];
    const title = document.querySelector('[data-order-title]')
    const skuText = document.querySelector("[data-order-sku]")
    
    if (radioButtons.length !== 0) {
        updateInfoFromRadio()
        radioButtons.forEach(radioButton => {
            radioButton.addEventListener('change', e => {
                updateInfoFromRadio()
            })
        })
    }
    
    if (dropdownSelects.length !== 0) {
        updateInfoFromDropdown()
        dropdownSelects.forEach(select => {
            select.addEventListener('change', e => {
                updateInfoFromDropdown()
            })
        })
    }

    function updateInfoFromRadio() {
        const checkedRadio = document.querySelector("[data-product-radio]:checked");
        if (!checkedRadio) return;
        
        const radioButtonValue = checkedRadio.value;
        const variantLabel = checkedRadio.nextElementSibling;
        const variantSku = variantLabel.querySelector('[data-variant-sku]')
        const variantPricing = variantLabel.querySelector('[data-call-pdp]')
        
        updateOrderSummary(radioButtonValue, variantSku, variantPricing);
    }
    
    function updateInfoFromDropdown() {
        const variantSelects = document.querySelector('variant-selects');
        if (!variantSelects) return;
        
        const variantData = JSON.parse(variantSelects.querySelector('[type="application/json"]').textContent);
        const selects = variantSelects.querySelectorAll('select');
        const selectedValues = Array.from(selects, select => select.value);
        
        const currentVariant = variantData.find(variant => {
            return selectedValues.every((value, index) => {
                const optionKey = `option${index + 1}`;
                return variant[optionKey] === value;
            });
        });
        
        if (currentVariant) {
            const variantTitle = currentVariant.title;
            const variantSku = currentVariant.sku;

            if (title) title.textContent = variantTitle;
            if (skuText) {
                if (variantSku) {
                    skuText.textContent = `SKU: ${variantSku}`;
                } else {
                    skuText.textContent = "";
                }
            }
            
            const variantInput = document.querySelector('input[name="id"]');
            if (variantInput) {
                variantInput.value = currentVariant.id;
            }
            
            displayDropdownPrice(currentVariant);

            const variantSelectsEl = document.querySelector('variant-selects');
            if (variantSelectsEl && typeof variantSelectsEl.syncQuoteOnlyVariantUI === 'function') {
                variantSelectsEl.syncQuoteOnlyVariantUI();
            }
        }
    }
    
    function displayDropdownPrice(variant) {
        const price = variant.price || 0;
        let priceDisplay = document.querySelector('[data-dropdown-price]');

        // Quote ($0): main #price block already shows the tel link after section render — do not duplicate here.
        if (price <= 0) {
            if (priceDisplay) {
                priceDisplay.innerHTML = '';
                priceDisplay.classList.add('hidden');
                priceDisplay.style.display = 'none';
            }
            return;
        }

        if (!priceDisplay) {
            priceDisplay = createPriceDisplayElement();
        }
        if (!priceDisplay) return;

        priceDisplay.classList.remove('hidden');
        priceDisplay.style.display = 'block';
        priceDisplay.innerHTML = formatVariantPrice(variant);
    }
    
    function createPriceDisplayElement() {
        const skuElement = document.querySelector('[data-order-sku]');
        if (!skuElement) return null;
        
        const priceDisplay = document.createElement('p');
        priceDisplay.setAttribute('data-dropdown-price', '');
        priceDisplay.className = 'dropdown-variant-price order-summary-price';
        priceDisplay.style.margin = '0';
        priceDisplay.style.fontSize = '1.1rem';
        priceDisplay.style.fontWeight = '600';
        priceDisplay.style.color = '#121212';
        
        skuElement.insertAdjacentElement('afterend', priceDisplay);
        
        return priceDisplay;
    }
    
    function formatVariantPrice(variant) {
        const formattedPrice = formatMoney(variant.price || 0);
        return `<div class="variant-price-display">${formattedPrice}</div>`;
    }
    
    function formatMoney(cents) {
        const dollars = cents / 100;
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        });
        return formatter.format(dollars);
    }

    function updateOrderSummary(variantTitle, variantSku, variantPricing) {
        if (title) title.textContent = variantTitle;
        if (skuText) {
            if (variantSku) {
                const skuValue = variantSku.getAttribute("data-variant-sku");
                skuText.textContent = `SKU: ${skuValue}`;
            } else {
                skuText.textContent = "";
            }
        }

        const variantSelectsEl = document.querySelector('variant-selects');
        if (variantSelectsEl && typeof variantSelectsEl.syncQuoteOnlyVariantUI === 'function') {
            variantSelectsEl.syncQuoteOnlyVariantUI();
        }
    }

    function styleAndSortUnavailableOptions() {
        const selects = document.querySelectorAll('.select__select');
        
        selects.forEach(select => {
            if (select.closest('variant-selects')) return;

            const currentSelectedValue = select.value;
            
            const options = Array.from(select.querySelectorAll('option'));
            const availableOptions = [];
            const unavailableOptions = [];
            
            options.forEach(option => {
                option.classList.remove('unavailable-option');
                const text = option.textContent.trim();
                
                const isUnavailable = !option.selected && (
                    text.includes('Unavailable') || 
                    text.includes('unavailable') || 
                    text.includes('- Unavailable') ||
                    text.endsWith(' - Unavailable') ||
                    text.includes('Stripe - Unavailable') ||
                    text.toLowerCase().includes('out of stock')
                );
                
                if (isUnavailable) {
                    option.classList.add('unavailable-option');
                    unavailableOptions.push(option);
                } else {
                    availableOptions.push(option);
                }
            });
            
            select.innerHTML = '';
            
            availableOptions.forEach(option => {
                select.appendChild(option);
            });
            
            unavailableOptions.forEach(option => {
                select.appendChild(option);
            });
            
            if (currentSelectedValue) {
                select.value = currentSelectedValue;
            }
        });
    }

    styleAndSortUnavailableOptions();

    document.addEventListener('change', function(e) {
        if (e.target.classList.contains('select__select')) {
            setTimeout(styleAndSortUnavailableOptions, 100);
        }
    });

})();